<template class="main">
    <div class="main">

      <head>
        <link href="https://vjs.zencdn.net/7.5.4/video-js.css" rel="stylesheet">

      </head>
      <!-- ROW1 -->
      <!-- Encabezado PC -->
      
        <div align="center" class="row2" style="background-color:white">
          <v-flex  xs10 sm10 md10 lg10 xl10 >
            <p class="text-header">
                        {{header_text}}
            </p>
          </v-flex>
        </div>
      
        <v-layout class="hidden-sm-and-down" row wrap>
          <v-flex  xs12 sm12 md12 lg12 xl12 >
            <v-card dark color="white">        
              <v-img class="header_parents" src="header-home.jpg">
               <!-- <div class="vertical-center-home">
                  <v-flex xs10 sm10 md8 lg10>
                    <p class="text-top-title" style="font-family:Fredoka one;">
                      {{row1_text1}}
                    </p>
                    <p class="text-top-subtitle" style="font-family:Poppins">
                      {{row1_text2}}
                    </p> 
                  </v-flex>
                  <v-layout style="margin-left:-3%">

                    <v-flex style="padding:1vw;" xs5 sm5 md5 lg5>     
                      <a href="https://lalabumapp.com/dashboard_maestros/" target="_blank"> <v-img class="hidden-sm-and-down" flat style="height:100%;width:15vw;padding:0;" slot="activator"><v-img :src="row1_maestras" /></v-img></a>
                    
                    
                  
                    </v-flex>
                    <v-flex style="padding:1vw" xs4 sm4 md2 lg2>
                      
                      <a href="https://www.lalabumapp.com/padres/?sincache" target="_black"> <v-img class="hidden-sm-and-down" flat style="height:100%;width:15vw;padding:0;" slot="activator"><v-img :src="row1_padres" /></v-img></a>
                      
                    </v-flex> 

                  </v-layout>
                  <p class="text-top-frase" style="font-family:Poppins">
                    {{row1_text3}}
                  </p>
              
                  <v-layout style="">
                    <v-flex  style="padding:0vw" xs5 sm5 md4 lg4>
                      <a href="https://apps.apple.com/mx/app/mundo-lalabum/id1414963543" target="_blank">
                      <v-img :src="row1_img1"></v-img>
                      </a>
                  </v-flex>
                  <v-flex style="padding:0vw;margin-left:4%" xs5 sm5 md4 lg4>
                    <a href="https://play.google.com/store/apps/details?id=com.Lalabum.MundoLalabum" target="_blank">
                    <v-img :src="row1_img2"></v-img>
                    </a>
                  </v-flex>
                </v-layout>
              </div> -->      
            </v-img>
          </v-card>
        </v-flex> 
      </v-layout>


      <!-- Encabezado Movil -->
      <v-layout class="hidden-md-and-up" row wrap>
        <v-flex xs12 sm12>
          <v-img src="header-home-mobile.jpg">
           <!-- <div class="vertical-center-home-mobile">
                  <v-flex xs10 sm10 md8 lg10>
                    <p class="text-top-title-mobile" style="font-family:Fredoka one; color:white; font-size:6.5vw; text-align:center; line-height:110%">
                      {{row1_text1}}
                    </p>
                    <p class="text-top-subtitle-mobile" style="font-family:Poppins; color:white; font-size:4vw; text-align:center; line-height:110%; margin-top:-10px">
                      {{row1_text2}}
                    </p> 
                  </v-flex>
                  <v-layout style="margin-top:-3%">

                    <v-flex style="padding:1vw;" xs5 sm5 md5 lg5>     
                      
                      <a href="https://lalabumapp.com/dashboard_maestros/#/" target="_blank"><v-img flat slot="activator"  :src="row1_maestras"></v-img></a>
                      
                      <a href="https://www.lalabumapp.com/padres/?sincache" target="_blank"><v-img style="margin-top:10%" flat slot="activator"  :src="row1_padres"></v-img></a>
                    </v-flex> 
                     <v-flex style="padding:1vw; margin-left:7%" xs4 sm4 md5 lg5>     
                      <a href="https://apps.apple.com/mx/app/mundo-lalabum/id1414963543" target="_blank">
                      <v-img :src="row1_img1"></v-img>
                      </a>
                    
                      <a href="https://play.google.com/store/apps/details?id=com.Lalabum.MundoLalabum" target="_blank">
                    <v-img :src="row1_img2"></v-img>
                    </a>
                    </v-flex> 
                  </v-layout>
              </div>  -->     

          </v-img>


        </v-flex>

      </v-layout>

    <!--ROW2-->

  <br>
   <div align="center" class="row2" style="background-color:white">
          <v-flex  xs10 sm10 md10 lg10 xl10 >
            <p class="text-header">
                        {{header_text2}}
            </p>
          </v-flex>
        </div>  

    <!--Lalabum es: Titulo -->
  <!--<v-layout justify-center row wrap >
      <v-flex sm12 md12 lg12>
        <v-card dark color="white">        
          <v-img class="blueback_home"
              src="home_back_azul.png"
            >
            <div align="center" class="row2">
              <v-flex xs10 sm10 md10 lg10 class="hidden-sm-and-down">
                <p  style="font-family:Fredoka one;font-size:2.3vw">
                  {{row2_text1}}
                </p>
                
                </v-flex>
                <v-flex xs10 sm10 md10 lg10 class="hidden-md-and-up">
                <p  style="font-family:Fredoka one;font-size:6.5vw">
                  {{row2_text1}}
                </p>
                
                </v-flex>-->

        <!--Lalabum es: iconos PC-->
              <!--<v-flex class="md_screen hidden-sm-and-down" xs12 sm12 md10 lg10>
        <v-layout justify-center class="iconos" >
        <v-flex  style="padding:5vw" xs5 sm5 md3 lg3>-->
            <!--<v-img src="home_iconos_dibujos.png"></v-img> --> 
            <!--<v-btn class="no_hover" fab dark large @click.stop="dialog = true">
              <img src="dibujos.png" width="150px" style="margin-top:-10%"/>
              </v-btn> 
               <v-dialog
      v-model="dialog"
      max-width="1000"
    >
      <v-card>
          <v-card-actions>
          <v-spacer></v-spacer>
        <v-btn  fab dark color="#2f478d"  @click="dialog = false">
        <p style="font-family:Fredoka one; font-size:2.6vw">X</p>-->
        <!--<v-icon dark x-large>close</v-icon>-->
    <!--</v-btn>
        </v-card-actions>

        <v-card-title class="headline" ></v-card-title>
            <div align="center" style="margin-top:-8%">
            <v-img :src="row2_popup1" width="900px"></v-img> </div>
        <v-card-text>
          
        </v-card-text>

      </v-card>
    </v-dialog>
              <br><p  style="font-family:Fredoka one; font-size:1.5vw; font-weight:200;">{{row2_text2}}</p>
                    
        </v-flex>
        <v-flex class="" style="padding:5vw" xs4 sm4 md3 lg3>-->
            <!--<v-img src="musica.png"></v-img>-->
            <!--<v-btn class="no_hover" fab dark large @click.stop="dialog2 = true">
              <img src="musica.png" width="125px" style="margin-top:-10%"/>
            </v-btn> 
            <v-dialog
                v-model="dialog2"
                max-width="1000"
              >
                <v-card>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn  fab dark color="#2f478d"  @click="dialog2 = false">
                        <p style="font-family:Fredoka one; font-size:2.6vw">X</p>-->
                        <!--<v-icon dark x-large>close</v-icon>-->
                      <!--</v-btn>
                    </v-card-actions>

                    <v-card-title class="headline" ></v-card-title>
                      <div align="center" style="margin-top:-8%">
                      <v-img :src="row2_popup2" width="900px"></v-img> </div>
                    <v-card-text>
                    
                  </v-card-text>

                </v-card>
            </v-dialog>
            <br><p style="font-family:Fredoka one; font-size:1.5vw; font-weight:200">{{row2_text3}}</p>  
        </v-flex>
        <v-flex class="" style="padding:5vw" xs4 sm4 md3 lg3>-->
            <!--<v-img src="cuentos_2.png"></v-img>-->
           <!-- <v-btn class="no_hover" fab dark large @click.stop="dialog3 = true">
              <img src="cuentos.png" width="125px" style="margin-top:-10%"/>
              </v-btn> 
              <v-dialog
                    v-model="dialog3"
                    max-width="1000"
                  >
                    <v-card>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                          <v-btn  fab dark color="#2f478d"  @click="dialog3 = false">
                            <p style="font-family:Fredoka one; font-size:2.6vw">X</p>-->
                      <!--<v-icon dark x-large>close</v-icon>-->
                          <!--</v-btn>
                      </v-card-actions>

                      <v-card-title class="headline" ></v-card-title>
                          <div align="center" style="margin-top:-8%">
                          <v-img :src="row2_popup3" width="900px"></v-img> </div>
                      <v-card-text>
                        
                      </v-card-text>

                    </v-card>
    </v-dialog>
            <br><p style="font-family:Fredoka one; font-size:1.5vw; font-weight:200">{{row2_text4}}</p>  
        </v-flex>
        <v-flex class="" style="padding:5vw" xs4 sm4 md3 lg3>-->
            <!--<v-img src="juego.png"></v-img>-->
            <!--<v-btn class="no_hover" fab dark large @click.stop="dialog4 = true">
              <img src="juegos.png" width="125px" style="margin-top:-10%"/>
              </v-btn> 
              <v-dialog
                    v-model="dialog4"
                    max-width="1000"
                  >
                    <v-card>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                          <v-btn  fab dark color="#2f478d"  @click="dialog4 = false">
                            <p style="font-family:Fredoka one; font-size:2.6vw">X</p>-->
                      <!--<v-icon dark x-large>close</v-icon>-->
                         <!-- </v-btn>
                      </v-card-actions>

                      <v-card-title class="headline" ></v-card-title>
                          <div align="center" style="margin-top:-8%">
                          <v-img :src="row2_popup4" width="900px"></v-img> </div>
                      <v-card-text>
                        
                      </v-card-text>

                    </v-card>
              </v-dialog>
                <br><p style="font-family:Fredoka one; font-size:1.5vw; font-weight:200">{{row2_text5}}</p>  
        </v-flex>
        <v-flex class="" style="padding:5vw;" xs4 sm4 md3 lg3>-->
            <!--<v-img src="videos.png"></v-img>-->
            <!--<v-btn class="no_hover" fab dark large @click.stop="dialog5 = true">
              <img src="videos.png" width="125px" style="margin-top:-10%"/>
              </v-btn>
              <v-dialog
                    v-model="dialog5"
                    max-width="1000"
                  >
                    <v-card>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                          <v-btn  fab dark color="#2f478d"  @click="dialog5 = false">
                            <p style="font-family:Fredoka one; font-size:2.6vw">X</p>-->
                      <!--<v-icon dark x-large>close</v-icon>-->
                         <!-- </v-btn>
                      </v-card-actions>

                      <v-card-title class="headline" ></v-card-title>
                          <div align="center" style="margin-top:-8%">
                          <v-img :src="row2_popup5" width="900px"></v-img> </div>
                      <v-card-text>
                        
                      </v-card-text>

                    </v-card>
              </v-dialog>
              <br><p style="font-family:Fredoka one; font-size:1.5vw; font-weight:200">{{row2_text6}}</p>  
        </v-flex>
        </v-layout>
      </v-flex>-->

      <!--Lalabum es: iconos movil-->
       <!--<v-flex class="hidden-md-and-up" xs12 sm12 md10 lg10 offset-md1 offset-lg1 >
        <v-layout justify-center class="">
        <v-flex class="text-iconosmv" style="padding:5vw" xs4 sm4 md3 lg3>-->
            <!--<v-img src="home_iconos_dibujos.png"></v-img>-->
            <!--v-btn fab dark large @click.stop="dialog6 = true">
              <img src="dibujos.png" width="95px" style="margin-top:-8%"/>
              </v-btn> 
              <v-dialog
                  v-model="dialog6"
                  max-width="345"
                >
                  <v-card>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn  fab dark color="#2f478d"  @click="dialog6 = false">
                          <p style="font-family:Fredoka one; font-size:9vw;">X</p>-->
                          <!--<v-icon dark x-large>close</v-icon>-->
                      <!--</v-btn>
                    </v-card-actions>

                    <v-card-title class="headline" ></v-card-title>
                        <div align="center" style="margin-top:-8%">
                        <v-img :src="row2_popupm1" width="318px"></v-img> </div>
                    <v-card-text>
                      
                    </v-card-text>

                  </v-card>
                </v-dialog>
            <br><p style="font-family:Fredoka one; font-size:4.5vw; font-weight:600; margin-left:-11px">{{row2_text2}}</p>     
        </v-flex>
        <v-flex class="text-iconosmv" style="padding:5vw" xs4 sm4 md3 lg3>-->
            <!--<v-img src="musica.png"></v-img>-->
            <!--<v-btn fab dark large @click.stop="dialog7 = true">
              <img src="musica.png" width="95px" style="margin-top:-8%"/>
              </v-btn> 
              <v-dialog
                  v-model="dialog7"
                  max-width="345"
                >
                  <v-card>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn  fab dark color="#2f478d"  @click="dialog7 = false">
                          <p style="font-family:Fredoka one; font-size:9vw">X</p>-->
                          <!--<v-icon dark x-large>close</v-icon>-->
                      <!--</v-btn>
                    </v-card-actions>

                    <v-card-title class="headline" ></v-card-title>
                        <div align="center" style="margin-top:-8%">
                        <v-img :src="row2_popupm2" width="318px"></v-img> </div>
                    <v-card-text>
                      
                    </v-card-text>

                  </v-card>
                </v-dialog>
             <br><p style="font-family:Fredoka one; font-size:4.5vw; font-weight:600">{{row2_text3}}</p>  
        </v-flex>
        </v-layout>
        <v-layout justify-center class="iconos">
        <v-flex class="text-iconosmv" style="padding:5vw" xs4 sm4 md3 lg3>-->
            <!--<v-img src="cuentos_2.png"></v-img>-->
            <!--<v-btn fab dark large @click.stop="dialog8 = true">
              <img src="cuentos.png" width="95px" style="margin-top:-8%"/>
              </v-btn>  
              <v-dialog
                  v-model="dialog8"
                  max-width="345"
                >
                  <v-card>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn  fab dark color="#2f478d"  @click="dialog8 = false">
                          <p style="font-family:Fredoka one; font-size:9vw">X</p>-->
                          <!--<v-icon dark x-large>close</v-icon>-->
                      <!--</v-btn>
                    </v-card-actions>

                    <v-card-title class="headline" ></v-card-title>
                        <div align="center" style="margin-top:-8%">
                        <v-img :src="row2_popupm3" width="318px"></v-img> </div>
                    <v-card-text>
                      
                    </v-card-text>

                  </v-card>
                </v-dialog>
            <br><p style="font-family:Fredoka one; font-size:4.5vw; font-weight:600">{{row2_text4}}</p>      
        </v-flex>
        <v-flex class="text-iconosmv" style="padding:5vw" xs4 sm4 md3 lg3>-->
            <!--<v-img src="juego.png"></v-img>-->
            <!--<v-btn fab dark large @click.stop="dialog9 = true">
              <img src="juegos.png" width="95px" style="margin-top:-8%"/>
              </v-btn>
              <v-dialog
                  v-model="dialog9"
                  max-width="345"
                >
                  <v-card>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn  fab dark color="#2f478d"  @click="dialog9 = false">
                          <p style="font-family:Fredoka one; font-size:9vw">X</p>-->
                          <!--<v-icon dark x-large>close</v-icon>-->
                      <!--</v-btn>
                    </v-card-actions>

                    <v-card-title class="headline" ></v-card-title>
                        <div align="center" style="margin-top:-8%">
                        <v-img :src="row2_popupm4" width="318px"></v-img> </div>
                    <v-card-text>
                      
                    </v-card-text>

                  </v-card>
                </v-dialog>
            <br><p style="font-family:Fredoka one; font-size:4.5vw; font-weight:600">{{row2_text5}}</p>  
        </v-flex>
        </v-layout>
        <v-layout justify-center class="iconos">
        <v-flex class="text-iconosmv" style="padding:5vw" xs4 sm4 md3 lg3>-->
            <!--<v-img src="videos.png"></v-img>-->
            <!--<v-btn fab dark large @click.stop="dialog10 = true">
              <img src="videos.png" width="95px" style="margin-top:-8%"/>
              </v-btn>
              <v-dialog
                  v-model="dialog10"
                  max-width="345"
                >
                  <v-card>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn  fab dark color="#2f478d"  @click="dialog10 = false">
                          <p style="font-family:Fredoka one; font-size:9vw">X</p>-->
                          <!--<v-icon dark x-large>close</v-icon>-->
                      <!--</v-btn>
                    </v-card-actions>

                    <v-card-title class="headline" ></v-card-title>
                        <div align="center" style="margin-top:-8%">
                        <v-img :src="row2_popupm5" width="318px"></v-img> </div>
                    <v-card-text>
                      
                    </v-card-text>

                  </v-card>
                </v-dialog>
            <br><p style="font-family:Fredoka one; font-size:4.5vw; font-weight:600">{{row2_text6}}</p>        
        </v-flex>
        </v-layout>
      </v-flex>-->

      <!--Lalabum es: subtitutulo-->
      <!--<v-flex xs10 sm10 md10 lg10 class="hidden-sm-and-down">
                <p class="text-top-title" style="font-family:Fredoka one;font-size:2vw;text-align:center">
                  {{row2_text7}}
                </p>
                <div class="hidden-sm-and-down">
                <br></div>
                </v-flex>
                <v-flex xs10 sm10 md10 lg10 class="hidden-md-and-up">
                <p class="" style="font-family:Fredoka one;font-size:5.5vw; text-align:center">
                  {{row2_text7}}
                </p>
                </v-flex>
                <br>
                <a class="butn_more" href="https://lalabumapp.com/conocemas" target=_blank>{{row2_button}}</a>
            </div>        
        </v-img>
        </v-card>
      </v-flex> 
    </v-layout>-->



    
<!--ROW3-->
<v-layout justify-center row wrap>
      <v-flex sm12 md12>    
            <div align="center" class="row3">
              <v-flex xs10 sm10 md10 lg10 class="hidden-sm-and-down">
                <br><p style="font-family:Poppins;font-size:1.6vw">
                  {{row3_text1}}
                </p>
                
                </v-flex>
                <v-flex xs11 sm11 md10 lg10 class="hidden-md-and-up">
                <p  style="font-family:Poppins;font-size:4.5vw">
                  <br>{{row3_text1}}
                </p>
                
                </v-flex>

                 <!-- PC -->
                  <v-layout  row wrap>
                  <v-flex sm12 md12 >
                    <v-card flat dark color="white">        
                      <v-img
                          src="propuesta_educativa.png"
                        >
                      
                                  
                    </v-img>
                    </v-card>
                  </v-flex> 
                </v-layout>

        <!--Niños, Escuelas,Maestros PC-->
              <v-flex class="md_screen hidden-sm-and-down" xs12 sm12 md11 lg11 style="margin-top:30px" >
        <v-layout justify-center>
        <v-flex  style="padding:4vw" xs7 sm7 md6 lg6>
          <v-card 
          style="border-radius:15px;" 
          class="mx-auto"
          color="#0CB0CD"
          dark
          max-width="400"   
          >
          <br>
          <v-img :src="logo_preescolar" width='70%'></v-img> 
          <br>
          <v-card-text class="text-h5 " style="font-family:poppins; font-size:16px; font-weigth:400">
            En Preescolar nos enfocamos en el desarrollo de sus habilidades socio emocionales , 
            inculcando buenos hábitos y actitudes de comunicación para mejorar su conducta dentro y fuera de la escuela.
           </v-card-text>
           <v-img :src="icono_preescolar" width='70%' class="ml-auto"></v-img> 
          </v-card>
            <!--<v-img :src="row3_img1"></v-img> -->        
        </v-flex>
        <v-flex class="" style="padding:4vw" xs6 sm6 md6 lg6>
           <v-card 
          style="border-radius:15px;" 
          class="mx-auto"
          color="#CB219A"
          dark
          max-width="400"   
          >
          <br>
          <v-img :src="logo_primaria" width='70%'></v-img> 
          <v-card-text class="text-h5 " style="font-family:poppins; font-size:15px; font-weigth:400">
            En Primaria los guiamos hacia el descubrimiento de su identidad personal, 
            cuales son sus talentos y como utilizarlos para obtener beneficios personales conviviendo bajo las normas y aprendiendo a solucionar problemas con creatividad.
           </v-card-text>
          
           <v-img :src="icono_primaria" width='70%' class="mr-auto"></v-img> 
           
          </v-card>
        </v-flex>
        <v-flex class="" style="padding:4vw" xs6 sm6 md6 lg6>
            <v-card 
          style="border-radius:15px;" 
          class="mx-auto"
          color="black"
          dark
          max-width="400"   
          >
          <br>
          <v-img :src="logo_secundaria" width='70%'></v-img> 
          <v-card-text class="text-h5 " style="font-family:poppins; font-size:15px; font-weigth:400">
            En Secundaria conocen los elementos necesarios para administrar su tiempo y dinero. A orientarse hacia su vocación y a partir de ella plantearse metas para diseñar su proyecto de vida exitoso basado en el auto empleo con
            responsabilidad social.
           </v-card-text>
          
           <v-img :src="icono_secundaria" width='70%' class="mr-auto"></v-img> 
           
          </v-card>
        </v-flex>
        </v-layout>
      </v-flex>

      <!--Niños, Escuelas, Maestros movil-->
       <v-flex class="md_screen hidden-md-and-up" xs12 sm12 md10 lg10 offset-md1 offset-lg1 >
        <v-layout justify-center class="iconos">
        <v-flex style="padding:3vw" xs10 sm10 md3 lg3>
            <v-card 
          style="border-radius:15px;" 
          class="mx-auto"
          color="#0CB0CD"
          dark
          max-width="400"   
          >
          <br>
          <v-img :src="logo_preescolar" width='70%'></v-img> 
          <br>
          <v-card-text class="text-h5 " style="font-family:poppins; font-size:20px; font-weigth:400">
            En Preescolar nos enfocamos en el desarrollo de sus habilidades socio emocionales , 
            inculcando buenos hábitos y actitudes de comunicación para mejorar su conducta dentro y fuera de la escuela.
           </v-card-text>
           <v-img :src="icono_preescolar" width='90%' class="ml-auto"></v-img> 
          </v-card>          
        </v-flex>
        </v-layout>
        <v-layout justify-center class="iconos">
        <v-flex style="padding:5vw" xs10 sm10 md3 lg3>
            <v-card 
          style="border-radius:15px;" 
          class="mx-auto"
          color="#CB219A"
          dark
          max-width="400"   
          >
          <br>
          <v-img :src="logo_primaria" width='70%'></v-img> 
          <v-card-text class="text-h5 " style="font-family:poppins; font-size:20px; font-weigth:400">
            En Primaria los guiamos hacia el descubrimiento de su identidad personal, 
            cuales son sus talentos y como utilizarlos para obtener beneficios personales conviviendo bajo las normas y aprendiendo a solucionar problemas con creatividad.
           </v-card-text>
          
           <v-img :src="icono_primaria" width='90%' class="mr-auto"></v-img> 
           
          </v-card>    
        </v-flex>
        </v-layout>
        <v-layout justify-center class="iconos">
        <v-flex style="padding:5vw" xs10 sm10 md3 lg3>
            <v-card 
          style="border-radius:15px;" 
          class="mx-auto"
          color="black"
          dark
          max-width="400"   
          >
          <br>
          <v-img :src="logo_secundaria" width='70%'></v-img> 
          <v-card-text class="text-h5 " style="font-family:poppins; font-size:20px; font-weigth:400">
            En Secundaria conocen los elementos necesarios para administrar su tiempo y dinero. A orientarse hacia su vocación y a partir de ella plantearse metas para diseñar su proyecto de vida exitoso basado en el auto empleo con
            responsabilidad social.
           </v-card-text>
           <v-img :src="icono_secundaria" width='90%' class="mr-auto"></v-img> 
          </v-card>          
        </v-flex>
        </v-layout>
      </v-flex>
            </div>        
      </v-flex> 
    </v-layout>



    <!--ROW4 PC-->
    <!--Beneficios PC -->
  <!--<v-layout class="hidden-sm-and-down" justify-center row wrap>
      <v-flex sm12 md12 >
        <v-card flat dark color="white">        
          <v-img class="greenback_home"
              src="home_fondoverde750.png"
            >
            <div align="center" class="row4">
              <v-flex xs10 sm10 md10 lg10>
                <p  style="font-family:Fredoka one;font-size:2.3vw">
                  {{row4_text1}}
                </p>           
                
                </v-flex>

              <v-flex xs12 sm12 md10 lg10 style="margin-top:-6%" >
        <v-layout justify-center class="iconos">
        <v-flex  style="padding:4vw" xs2 sm3 md3 lg3>
           
              <v-img slot="badge" @mouseover="mostrar1" @mouseout="cerrar1" src="maestros.png"></v-img>
            
               
                   
        </v-flex>
        <v-flex class="" style="padding:4vw" xs2 sm2 md3 lg3>
            
            <v-img slot="badge" @mouseover="mostrar2" @mouseout="cerrar2" src="ninos.png"></v-img> 
            
        </v-flex>
        <v-flex class="" style="padding:4vw" xs2 sm2 md3 lg3>
            <v-img slot="badge" @mouseover="mostrar3" @mouseout="cerrar3" src="padres.png"></v-img>
        </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12 sm12 md10 lg10 style="margin-top:-3%" >
        
      

      <div class="textoBeneficios" align="center">
        <div class="beneficios" id="flotante"  align="justify"><p>{{row4_text2}}</p></div>
        <div class="beneficios" id="flotante2" style="display:none;" align="center">{{row4_text3}}</div>
        <div class="beneficios" id="flotante3" style="display:none;" align="left">{{row4_text4}} </div>
    </div>
      </v-flex>

            </div>        
        </v-img>
        </v-card>
      </v-flex> 
    </v-layout>-->


  


    <!--Beneficios Movil-->
    <!--<v-layout class="hidden-md-and-up" justify-center row wrap>
      <v-flex sm12 md12 >
        <v-card flat dark color="#3490CD" >        
          <v-img class="greenback_home"
              src="fondoverdemobile.png"
            >
            <div align="center" class="row4">
              <v-flex xs10 sm10 md10 lg10>
                <p  style="font-family:Fredoka one;font-size:7vw;color:white">
                  {{row4_text1}}
                </p>           
                
                </v-flex>

                <v-flex style="padding:4vw" xs12 sm12 md6 lg8 xl10 display:inline-flex;justify-content: space-evenly>
  <v-carousel class="remove-shadow" hide-delimiters hide-controls height="min-contain">
    <v-carousel-item
      v-for="(item,i) in items"
      :key="i"
      :src="item.src"
    ></v-carousel-item>
  </v-carousel>
        </v-flex>
            </div>        
        </v-img>
        </v-card>
      </v-flex> 
    </v-layout>-->
    

<!-- Probar Carrusel -->

<!-- FIN -->




    <!-- OBTEN EL PROGRAMA LALABUM PARA TU KINDER -- NUESTRO PROGRAMA INCLUYE -->

     

    <!--<a class='hidden-sm-and-down' href='https://calendly.com/lalabum/lalabum' target="_blank" ><img :src='row6_img1' /></a>-->
    <br>
    <div align="center" class="hidden-sm-and-down">
      <v-flex sm12 md11 lg11>
    <a href="https://calendly.com/lalabum/lalabum" class="school" target="_blank">Integra a tu escuela</a>
    <p style="color:#2F488E; font-family:poppins; font-size:30px; font-weight:500">Al programa educativo que forma a la nueva generación de líderes con autonomía, iniciativa y valores</p>
    </v-flex>
    </div>
    <div align="center" class="hidden-md-and-up">
      <v-flex sm12 md11 lg11>
    <a href="https://calendly.com/lalabum/lalabum" class="school" target="_blank">Integra a tu escuela</a>
    <br><br>
    <p style="color:#2F488E; font-family:poppins; font-size:20px; font-weight:500">Al programa educativo que forma a la nueva generación de líderes con autonomía, iniciativa y valores.</p>
    
    </v-flex>
    </div>    

 

    <!-- Button Scrool-->

          <!--<a class='hidden-sm-and-down btncontact' href='https://calendly.com/lalabum/lalabum' target="_blank" ><img :src='row6_img1' /></a>
          <a class='hidden-md-and-up btncontact' href='https://calendly.com/lalabum/lalabum' target="_blank"><img :src='row6_img1' width="200"/></a>-->
                    
   <!-- Dialog TIENDA -->  

   <!--ROW3-->
<v-layout justify-center>
      <v-flex sm12 md12>    
            <div align="center" class="row3">
             

        <!--Niños, Escuelas,Maestros PC-->
              <v-flex class="md_screen hidden-sm-and-down" xs12 sm12 md11 lg11  >
        <v-layout justify-center>
        <v-flex   xs7 sm7 md8 lg8>
          <br><br><br>
          <v-img :src="plataforma" width='70%'></v-img>      
        </v-flex>
        <v-flex  xs6 sm6 md8 lg8>
          <br><br><br>
          <v-img :src="libros" width='70%'></v-img> 
        </v-flex>
      
        </v-layout>
      </v-flex>

      <!--Niños, Escuelas, Maestros movil-->
       <v-flex class="md_screen hidden-md-and-up" xs12 sm12 md10 lg10 offset-md1 offset-lg1 >
        <v-layout justify-center >
        <v-flex style="padding:3vw" xs12 sm12 md3 lg3>
          <v-img :src="plataforma" width='100%'></v-img>    
        </v-flex>
        </v-layout>
        <v-layout justify-center >
        <v-flex style="padding:3vw" xs12 sm12 md3 lg3>   
          <v-img :src="libros" width='100%'></v-img> 
        </v-flex>
        </v-layout>
     
      </v-flex>
            </div>        
      </v-flex> 
    </v-layout>  


    <v-layout class="hidden-sm-and-down" row wrap>
          <v-flex  xs12 sm12 md12 lg12 xl12 >
            <v-card dark color="white">    
              <br><br> 
              <v-img class="header_parents" :src="alumnos_latam">   
            </v-img>
          </v-card>
        </v-flex> 
      </v-layout>   
      <v-layout class="hidden-md-and-up" row wrap>
          <v-flex  xs12 sm12 md12 lg12 xl12 >
            <v-card dark color="white">    
              <br><br> 
              <v-img class="header_parents" :src="alumnos_latam_mobile">   
            </v-img>
          </v-card>
        </v-flex> 
      </v-layout>   

      <br>
    <div align="center" class="hidden-sm-and-down">
      <v-flex sm12 md11 lg11>
    <a href="https://calendly.com/lalabum/lalabum" class="schoolorange" target="_blank">AGENDA AQUI <br>TU CITA VIRTUAL</a>
    <br><br>
    </v-flex>
    </div>
    <div align="center" class="hidden-md-and-up">
      <v-flex sm12 md11 lg11>
    <a href="https://calendly.com/lalabum/lalabum" class="schoolorange" target="_blank">AGENDA AQUI TU CITA VIRTUAL</a>    
    
    <br><br>
    </v-flex>
    </div>    
   
   <v-row justify="center">
    <!--<v-btn
      color="primary"
      dark
      @click.stop="dialog = true"
    >
      Open Dialog
    </v-btn>-->

    <v-dialog
      v-model="dialogtienda"
      max-width="300"
    >
      <v-card>
        <v-card-title class="headline" align="center" >
         <span style="font-family:Fredoka one; color:#792364"> Conoce nuestra tienda de juegos didácticos Lalabum </span>
        </v-card-title>

        <v-card-text>
          <span style="font-family:Poppins; color:#222222;font-weight:500">Lalabum ahora tiene una seccion de tienda, haz click aqui y revisa nuestros productos y servicioelige el que mas se adapte a lo que necesitas para tus niños.</span>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            text
            @click="dialogtienda = false"
          >
            Cerrar
          </v-btn>
          <!--<a href="https://lalabumapp.com/tienda/#/" style="text-decoration:none">-->
          <v-btn 
            color="primary" href="https://lalabumapp.com/tienda/#/" target="_blank"
            text
          >
            Ir a tienda
          </v-btn>
          <!--</a>-->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>    

    </div>



</template>


<script src='https://vjs.zencdn.net/7.5.4/video.js'></script>
<script type="text/javascript">
var myPlayer = videojs('my-video');
myPlayer.on('timeupdate', function() {
  console.log(this.currentTime());
});
</script>

<script>
 import loginbutton from "../components/login-button"
 import registerbutton from "../components/register-button"
 import reproductor from "../components/Reproductor"



  export default {
     components:{
       loginbutton,
       registerbutton,
       reproductor

     },

    
    data() {    
    let language=localStorage.getItem('language');   
    
    
    if (language=='es-XL' || language=='es')   
    
      {
        return{
          dialogvideo:false,
          dialogvideo1:false,
          dialog: false,
          dialog2:false,
          dialog3:false, 
          dialog4:false,
          dialog5:false,
          dialog6:false,
          dialog7:false,
          dialog8:false,
          dialog9:false,
          dialog10:false,
          dialogcontact:false,
          dialogtienda:false,
          Message1:'',
          name:'',
          email:'',
          select:'',
          school:'',
          logo_preescolar: "Lalabum-logohorizontal20080.png",
          icono_preescolar: "kid.png",
          logo_primaria: "empoderakids.png",
          logo_secundaria: "empoderateens.png",
          icono_secundaria:"girl.png",
          icono_primaria: "children.png",
          plataforma: "app.png",
          libros: "libros.png",
          alumnos_latam: "110.jpg",
          alumnos_latam_mobile: "110_movil.jpg",
          header_text: "Impulsa a tus alumnos a descubrir su talento",
          header_text2: "Para crecer como niños y jóvenes independientes",
          row1_text1:'Los valores no pasan de moda',          
          row1_text2:'Una divertida manera de enseñar a la nueva generación de líderes.',
          row1_text3:'¡Baja la app y sube sus valores!',
          row1_img:'btn_registrate.png',
          row1_maestras:'boton maestras.png',
          row1_padres:'boton padres.png',
          row1_img0:'btn__iniciarsesion.png',
          row1_img1:'appstore.png',
          row1_img2:'googleplay.png',
          row2_text1:'Lalabum es:',
          row2_img1:'home_iconos_dibujos.png',
          row2_img2:'musica.png',
          row2_img3:'cuentos_2.png',
          row2_img4:'juego.png',
          row2_img5:'videos.png',
          row2_text2:'Planeaciones',
          row2_text3:'Videos musicales',
          row2_text4:'Libros y actividades',
          row2_text5:'App móvil',
          row2_text6:'Videos',
          row2_button:'Conoce más',
          row2_popup1:'popups-desktop-dibujos_esp.png',
          row2_popup2:'canciones_popup_esp.png',
          row2_popup3:'cuentoss_popup_esp.png',
          row2_popup4:'popups-desktop_juegos_esp.png',
          row2_popup5:'popup_videos_esp.png',
          row2_popupm1:'popups_mobile_dibujos_esp.png',
          row2_popupm2:'canciones_popup_esp_mobile.png',
          row2_popupm3:'cuentos_popup_esp.png',
          row2_popupm4:'popups-juegos_mobile_esp.png',
          row2_popupm5:'popup_mobile_videos_esp.png',
          row2_text7:'para niños de 3 a 5 años',
          row3_text1:'Es una experiencia educativa que orienta a los estudiantes para que sean capaces de diseñar su proyecto de vida y enfrentar los retos de la vida con éxito.',
          //row3_text2:'une a padres, maestros y escuelas para fomentar el bienestar de los niños',
          row3_img1:'home-ninos.png',
          row3_img2:'home_padres.png',
          row3_img3:'home_maestros.png',
          row4_text1:'Beneficios',
          row4_text2:'Una experiencia educativa que contiene capacitaciones, planeaciones didácticas, recursos multimedia y materiales impresos, para que puedas trabajar y enseñarles a tus estudiantes la importancia de practicar sus valores y que adquieran habilidades que le permitirán relacionarse consigo mismo y con los demás de manera sana',
          row4_text3:'La herramienta más poderosa que le puedes enseñar a tus hijos es la formación de sus valores, ya que con ellos pueden adquirir habilidades emocionales y sociales para enfrentar su futuro de manera sana, siendo adultos responsables, empáticos, tolerantes y respetuosos con su entorno. Descarga nuestra app y ten la seguridad que tus hijos estarán practicando sus valores de manera divertida .',
          row4_text4:'Lalabum proporciona a los niños, a través de actividades didácticas y juegos, ejemplos de vida para que aprendan a utilizar sus valores e inteligencia emocional en la toma de decisiones. Los niños aprenden valores mientras se divierten en casa.',
          comprar_kitlalabum: '/comprar_kit.png',
          kit_lalabum1:'Actividades y juegos coloreables para',
          kit_lalabum2:'prácticar valores en cada grado preescolar',
          kit_lalabum3:'La tarjeta Lalabum incluye un código en',
          kit_lalabum4:'el cual podrás descargar nuestra app',
          kit_lalabum3_movil:'La tarjeta Lalabum incluye un',
          kit_lalabum4_movil:'código en el cual podrás',
          kit_lalabum5_movil:'descargar nuestra app',
          kit_lalabumapp:'appeducativa_icono.png',
          kit_lalabumamazon:'AMAZON.png',
          regalalabum:"En su cumpleaños o en ocasiones especiales regala valores, regala algo que les sirva toda su vida",
          row5_text1:'Blog',
          row5_text2:'9 - Abril - 2020',
          row5_text3:'Rutina de ejercicios divertida para niños en casa',
          row5_text4:'Motiva a los niños de la casa a que realicen actividades físicas, estos ejercicios le ayudan a tu hijo a sacar parte de su energía del día.',
          row5_text5:'26 - Marzo - 2020',
          row5_text6:'¡No te quedes sin celebrar momentos especiales en estos días!',
          row5_text7:'Si en tu casa hay niños que cumplen años en estos días de cuarentena, no dejes que lo pasen desapercibidos.',
          row5_text8:'12 - Marzo - 2020',
          row5_text9:'¿Te gustaría que tu hijo sea más independiente?',
          row5_text10:'Todos los niños pueden y deben ser educados para ser independientes, se les debe dar la oportunidad de realizar ciertas actividades.',
          row6_img1: 'contactanos1.png',
          row_img:'Recurso_6.png',
          items: [
          {
            src: 'mobile_maestros_esp.png'
          },
          {
            src: 'mobile_ninos_esp.png'
          },
          {
            src: 'mobile_escuela_esp.png'
          }
          
        ],
        titulovideo:"¿Como activar mi código Lalabum?" ,
        urlvideo:"https://www.lalabumapp.com/descargas/videos_capacitacion/3/ManualLicenciasLalabum.mp4",
        img:""
        }
      } else {
        return{
          dialogvideo:false,
          dialogvideo1:false,
          dialog: false,
          dialog2:false,
          dialog3:false, 
          dialog4:false,
          dialog5:false,
          dialog6:false,
          dialog7:false,
          dialog8:false,
          dialog9:false,
          dialog10:false,
          dialogcontact:false,
          dialogtienda:false,
          name:'',
          email:'',
          select:'',
          Message1:'',
          logo_preescolar: "Lalabum-logohorizontal20080.png",
          icono_preescolar: "kid.png",
          logo_primaria: "empoderakids.png",
          logo_secundaria: "empoderateens.png",
          icono_secundaria:"girl.png",
          icono_primaria: "children.png",
          plataforma: "app.png",
          libros: "libros.png",
          alumnos_latam: "110.jpg",
          alumnos_latam_mobile: "110_movil.jpg",
          header_text: "Impulsa a tus alumnos a descubrir su talento",
          header_text2: "Para crecer como niños y jóvenes independientes",
          row1_text1:"Values don't go out of style",
          row1_text2:'A fun way to teach the new generation of leaders.',
          row1_text3:'¡Download the app and upgrade their values!',
          row1_maestras:'boton teachers.png',
          row1_padres:'boton parents.png',
          row1_img:'registrate_eng.png',
          row1_img0:'iniciarsesion_eng.png',
          row1_img1:'appstore_eng.png',
          row1_img2:'googleplay_eng.png',
          row2_text1:'Lalabum is:',
          row2_img1:'home_iconos_dibujos.png',
          row2_img2:'musica.png',
          row2_img3:'cuentos_2.png',
          row2_img4:'juego.png',
          row2_img5:'videos.png',
          row2_text2:'Drawings',
          row2_text3:'Songs',
          row2_text4:'Stories',
          row2_text5:'Games',
          row2_text6:'Videos',
          row2_button:'Learn more',
          row2_popup1:'popups-desktop-drawings_eng.png',
          row2_popup2:'popups-desktop-music_eng.png',
          row2_popup3:'popups-desktop_stories_eng.png',
          row2_popup4:'popups-desktop-games_en.png',
          row2_popup5:'popups-desktop-videos_eng.png',
          row2_popupm1:'popups_mobile_drawings_eng.png',
          row2_popupm2:'popups_mobile_popup_eng.png',
          row2_popupm3:'popups_stories_mobile_eng.png',
          row2_popupm4:'popups-mobile_games_eng.png',
          row2_popupm5:'popups_videos_mobile_eng.png',
          row2_text7:'for kids from 3 to 5 years old',
          row3_text1:'Es una experiencia educativa que orienta a los estudiantes para que sean capaces de diseñar su proyecto de vida y enfrentar los retos de la vida con éxito.',
          row3_text2:"join parents, teachers, and schools to foster kid's well being",
          row3_img1:'kids.png',
          row3_img2:'parents.png',
          row3_img3:'teachers.png',
          row4_text1:'Benefits',
          row4_text2:'An educational experience that includes training, didactic plans, multimedia resources, and printed materials, so you can work and teach your students the importance of practicing their values and acquiring skills that will allow them to relate to themselves and others in a healthy way.',
          row4_text3:'The most powerful tool you can teach your children is the values formation because they acquire emotional and social skills to face their future in a healthy way, being responsible, empathic, tolerant and respectful adults with their environment. Download our app and have the certainty that your children will be practicing their values in a fun way.',
          row4_text4:'Lalabum provides children, through didactic activities and games, with real-life examples so that they learn to use their values ​​and emotional intelligence in decision-making. Children learn values while having fun at home.',
          comprar_kitlalabum:"buy_kit.png",
          kit_lalabum1:'Coloring, cut out and jigsaw didactic games devlop social and emotional skills.',
          kit_lalabum3:"The lalabum card includes a scratc off code to unlock lalabum's world app",
          kit_lalabum3_movil:"The lalabum card includes ",
          kit_lalabum4_movil:"a scratc off code to unlock",
          kit_lalabum5_movil:"lalabum's world app",
          kit_lalabumapp:'educationalapp_icon.png',
          kit_lalabumamazon:'AVAILABLE AT AMAZON.png',
          row5_text1:'Blog',
          row5_text2:'9 April 2020',
          row5_text3:'Fun exercise routine for kids at home',
          row5_text4:"Motivate children around the house to do physical activities, these exercises help your child get part of his energy from the day.",
          row5_text5:'26 March 2020',
          row5_text6:"Don't miss out on celebrating special moments these days!",
          row5_text7:"If there are children in your house who are turning years in these days of quarantine, do not let them go unnoticed.",
          row5_text8:'12 March 2020',
          row5_text9:'¿Would you like your child to be more independent?',
          row5_text10:"All children can and should be educated to be independent, they should be given the opportunity to do certain activities.",
          row6_img1:'contactus1.png',
          row_img:'Recurso_7.png',
          items: [
          {
            src: 'mobile_teachers_eng.png'
          },
          {
            src: 'mobile_child_eng.png'
          },
          {
            src: 'mobile_parents_eng.png'
          }
        ],
        items2: [
        'Soy Padre',
        'Soy Maestra',
        'Soy Lider Educativo'
      ],
      titulovideo:"¿How to activate my Lalabum code?",
      urlvideo:"https://www.lalabumapp.com/descargas/videos_capacitacion/3/ManualLicenciasLalabum.mp4",
      img:""
        

        }
      }
      
    },
    methods:{
    login: function () {
        let username = this.login_email 
        let password = this.login_password
        let client_id= '5c6c4ada410dfba504749c41';
        let client_secret = 'pP9s493s8xlzADfdMneOEgzrZ3J5l46CLXk5OLE8'
        let grant_type = 'password'
        let scope = '*'
        this.$store.dispatch('login', { grant_type, username, password,client_id,client_secret,scope })
       .then(() => this.$router.push('/padres-descargas'))
       .catch()
      },
      register: function () {
        let id = this.$uuid.v1();
        let data = {
          email: this.email,
          password: this.password,
          license: this.license,
          id_only: id,
          client_id:'5c6c4ada410dfba504749c41',
          platform:'windows'
        }
        this.$store.dispatch('register', data)
        .then(() => this.$router.push('/padres-descargas'))
        .catch()
      },

      /* BENEFICIOS */

      mostrar1: function() {
            let div = document.getElementById('flotante');
            div.style.display = '';
            
        },
        
      cerrar1: function() {
            let div = document.getElementById('flotante');
            div.style.display = '';
        },


      mostrar2: function(){
           let div = document.getElementById('flotante2');
            div.style.display = '';
            let div2 = document.getElementById('flotante');
            div2.style.display = 'none';
      },
      cerrar2: function(){
        let div = document.getElementById('flotante2');
            div.style.display = 'none';
        let div2 = document.getElementById('flotante');
            div2.style.display = '';
      },

      mostrar3: function() {
            let div = document.getElementById('flotante3');
            div.style.display = '';
            let div2 = document.getElementById('flotante');
            div2.style.display = 'none';
        },
        
      cerrar3: function() {
            let div = document.getElementById('flotante3');
            div.style.display = 'none';
            let div2 = document.getElementById('flotante');
            div2.style.display = '';
            
        
        },
        
        Close(){
           this.dialogvideo=false;
        },
        
    },

    beforeMount(){
      this.dialogtienda=true;
    }
    
    
  }

</script>

<style>

.main{
  background: white;
}

.school {
	background-color:#fed400;
	border-radius:5px;
	display:inline-block;
	cursor:pointer;
	color:#004bad;
	font-family: 'poppins';
	font-size:30px;
  font-weight: 500;
	padding:14px 14px;
	text-decoration:none;
	text-shadow:0px 1px 0px #2f6627;
}
.school:hover {
	background-color:#fed400;
}
.school:active {
	position:relative;
	top:1px;
}

.schoolorange {
	background-color:#FF914D;
	border-radius:10px;
	display:inline-block;
	cursor:pointer;
	color:white;
	font-family: 'fredoka one';
	font-size:30px;
  font-weight: 600;
	padding:14px 14px;
	text-decoration:none;
	
}
.schoolorange:hover {
	background-color:#FF914D;
}
.schoolorange:active {
	position:relative;
	top:1px;
}

@media screen and (max-width: 480px) {
  
.text-top-title{
    font-size: 4vw;
    text-align: center;
    line-height: 100%;
    
}

.text-header{
    font-size: 6.9vw;
    text-align: center;
    line-height: 90%;
    color:#2F488E;
    font-family: 'Fredoka one';
    
}

.text-top-subtitle{
    font-size: 2.4vw;
    text-align: left;
    line-height: 100%;
    
}
.text-top-frase{
    font-size: 2.5vw;
    text-align: center;
    font-weight: 600;
    margin-right: 20%;
    margin-bottom: 2%;
    
}
.blueback_home{
  height: 800px;
}

.greenback_home{
  height: 460px;
  
}

.butn_more {
  border-radius: 5px;
  font-family: "Poppins";
  font-weight: 500;
  color: #ffffff!important;
  font-size:6vw;
  background: #72b279;
  padding: 10px 25px 10px 25px;
  text-decoration: none;
  
}

.btncontact{
  margin-bottom: 17%;
}


}

@media screen and (min-width: 960px) {

.text-top-title{
    font-size: 3.2vw;
    text-align: left;
    line-height: 90%;
    
}

.text-header{
    font-size: 3.2vw;
    text-align: center;
    line-height: 90%;
    color:#2F488E;
    font-family: 'Fredoka one';
    
}

.text-top-subtitle{
    font-size: 1.8vw;
    text-align: left;
    line-height: 100%;
    
}

.text-top-frase{
    font-size: 2vw;
    text-align: left;
    font-weight: 600;
    
}

.blueback_home{
  height: 550px;
  
}

.greenback_home{
  height: 550px;

}


.butn_more {
  border-radius: 7px;
  font-family: "Poppins";
  font-weight: 500;
  color: #ffffff!important;
  font-size: 1.6vw;
  background: #72b279;
  padding: 5px 54px 5px 54px;
  text-decoration: none;
}

  }

.row2, .row4{
  
  position:relative;
  top: 3%;
 
}



.text-iconosmv p{
  font-size: 5vw;
}
  
.butn_more:hover {
  background: #489451;
  text-decoration:underline;
}

.row3 p{
  color:#952475;
}


.imgblog p{
  font-size: 1.1vw;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;

}

.imgblogmv p{
  font-size: 4vw;
}


.btncontact{
        /*display:scroll;*/
        /*position:fixed;*/
        bottom:0px;
        right:0px;
        z-index:100;
        margin-right: 0px;
    }


.remove-shadow{
  box-shadow:none !important;
  web-kit-box-shadow:none !important;
}

/*Beneficios*/
.textoBeneficios{
  color:white;
  font-size:18px;
  text-align:justify;
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  width: 70%;
 
}

.beneficios{
     padding-top: 5%;
     padding-bottom: 5%;
     padding-right:5%;
     padding-left:5%;
     text-align: justify;
}

#flotante{
    background-color:#772975;
    height:230px;
    border-radius:7px; 
     
}

#flotante2{
    background-color:#558BC3;
    height:230px;
    border-radius:7px;
}

#flotante3{
    background-color:#B53980;
    height:230px;
    border-radius:7px;
}


.remove-shadow{
  box-shadow:none !important;
  web-kit-box-shadow:none !important;
}


.text-top-row{
  font-size:2vw;
  font-family: 'Fredoka One', cursive;
}

.vertical-center-home{
  padding-left:55%;
  right: 4%;
  margin: 0px;
  position:absolute;
  top: 43%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.vertical-center-home-mobile{
  padding-left:12%;
  /*right: 4%;*/
  margin: 0px;
  position:absolute;
  top: 75%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
</style>
